/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsListQuery
 */
export interface IdentitySettingsListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentitySettingsListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsListQuery
     */
    distributionChannel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IdentitySettingsListQuery
     */
    agency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsListQuery
     */
    limit?: number | null;
}

export function IdentitySettingsListQueryFromJSON(json: any): IdentitySettingsListQuery {
    return IdentitySettingsListQueryFromJSONTyped(json, false);
}

export function IdentitySettingsListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : json['distributionChannel'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function IdentitySettingsListQueryToJSON(value?: IdentitySettingsListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': value.distributionChannel,
        'agency': value.agency,
        'offset': value.offset,
        'limit': value.limit,
    };
}


